import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { mainURL, prodURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
// import { ReDirectToeKMC2 } from "../components/ReDirectToeKMC2";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import DynamicPieChart from "../components/DynamicPieChart";
import MutationPieChart from "../components/MutationPieChart";

const Dashboard = () => {
  const [cmeData, setCmeData] = useState(null);
  const [chartData, setChartData] = useState([]);

  const navigate = useNavigate();
/////// For Ce-shop - Notification popup ///////////////////////
  const handleOrder = () => {
    const modal = document.getElementById("exampleModal2");

    if (modal) {
      modal.classList.remove("show");
      modal.style.display = "none";
      modal.setAttribute("aria-hidden", "true");
      modal.removeAttribute("aria-modal");
      // Remove Bootstrap backdrop
      document.querySelectorAll(".modal-backdrop").forEach((backdrop) => {
        backdrop.remove();
      });
  
      // Restore body
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("padding-right");
    }
  
    navigate("/Eodb_Notification");
  };
  /////// For Ce-shop - Notification popup - End ///////////////////////
  const { t } = useTranslation();

  const [mutationData, setMutationData] = useState([]);
  const [loadingMutation, setLoadingMutation] = useState(false);

  useEffect(() => {
    getMutationDashboardData();
    getCmeApplicationCount();
  }, []);

  const getCmeApplicationCount = async () => {
    try {
      const url = `${mainURL}/cme-civil-services/cme/_getApplicationCount`;
      const response = await axios.post(url, {});
      if (response && response.data) {
        const data = response.data;
        setCmeData(data);
        const total = Number(data.totalApplications) || 0;
        const inProgress = Number(data.inProgressApplications) || 0;
        const rejected = Number(data.rejectedApplications) || 0;
        const approved = Number(data.approvedApplications) || Math.max(0, total - inProgress - rejected);

        setChartData([
          { name: "Approved", value: approved },
          { name: "In Progress", value: inProgress },
          { name: "Rejected", value: rejected },
        ]);
      }
    } catch (error) {
      console.error("Error fetching CME application count:", error);
    }
  };

  const getMutationDashboardData = async () => {
    try {
      setLoadingMutation(true);
      const url = `${mainURL}/property-services/mutation/getEodbMutaionDashboard`;
      const response = await axios.post(url, {});
      const list = response?.data?.ResponseDataList || response?.data?.data || [];
      if (Array.isArray(list)) {
        setMutationData(list);
      }
    } catch (error) {
      console.error("Error fetching mutation dashboard data:", error);
    } finally {
      setLoadingMutation(false);
    }
  };

  const formatDays = (val) => {
    if (val !== null && val !== undefined && val !== "") {
      let num = val;
      if (typeof val === "string") {
        num = val.replace(/days?/gi, "").trim();
      }
      return (
        <div style={{ textAlign: "center", lineHeight: "1.2", padding: "2px 0" }}>
          <div>{num}</div>
          <div>Days</div>
        </div>
      );
    }
    return (
      <div style={{ textAlign: "center", lineHeight: "1.2", padding: "2px 0" }}>
        <div>-</div>
        <div>Days</div>
      </div>
    );
  };

  const formatCount = (val) => {
    if (val !== null && val !== undefined && val !== "") {
      return (
        <div style={{ textAlign: "center", lineHeight: "1.2", padding: "2px 0" }}>
          <div>{val}</div>
        </div>
      );
    }
    return (
      <div style={{ textAlign: "center", lineHeight: "1.2", padding: "2px 0" }}>
        <div>-</div>
      </div>
    );
  };

  const renderNestedMutationTable = (valueExtractor) => {
    if (!mutationData || mutationData.length === 0) {
      return (
        <div className="mayer-tb2" style={{ margin: 0 }}>
          <table className="deshbrd-tbl" style={{ width: "100%", margin: "6px 0", tableLayout: "fixed" }}>
            <thead>
              <tr className="table-clr1">
                <th style={{ textAlign: "center", verticalAlign: "middle", height: "36px" }}> - </th>
              </tr>
              <tr>
                <td style={{ textAlign: "center", verticalAlign: "middle", height: "38px" }}> - </td>
              </tr>
            </thead>
          </table>
        </div>
      );
    }

    const rows = [];
    for (let i = 0; i < mutationData.length; i += 2) {
      rows.push(mutationData.slice(i, i + 2));
    }

    return (
      <div className="mayer-tb2" style={{ margin: 0 }}>
        <table className="deshbrd-tbl" style={{ width: "100%", margin: "6px 0", tableLayout: "fixed" }}>
          {rows.map((row, idx) => (
            <thead key={idx}>
              <tr className="table-clr1">
                {row.length === 2 ? (
                  <>
                    <th style={{ width: "50%", textAlign: "center", verticalAlign: "middle", height: "36px", padding: "3px 4px", fontSize: "11px", wordBreak: "break-word" }}>
                      {t(row[0]?.mutationType) || row[0]?.mutationType}
                    </th>
                    <th style={{ width: "50%", textAlign: "center", verticalAlign: "middle", height: "36px", padding: "3px 4px", fontSize: "11px", wordBreak: "break-word" }}>
                      {t(row[1]?.mutationType) || row[1]?.mutationType}
                    </th>
                  </>
                ) : (
                  <th colSpan={2} style={{ textAlign: "center", verticalAlign: "middle", height: "36px", padding: "3px 4px", fontSize: "11px" }}>
                    {t(row[0]?.mutationType) || row[0]?.mutationType}
                  </th>
                )}
              </tr>
              <tr>
                {row.length === 2 ? (
                  <>
                    <td style={{ width: "50%", textAlign: "center", verticalAlign: "middle", height: "38px", padding: "2px 4px" }}>
                      {valueExtractor(row[0])}
                    </td>
                    <td style={{ width: "50%", textAlign: "center", verticalAlign: "middle", height: "38px", padding: "2px 4px" }}>
                      {valueExtractor(row[1])}
                    </td>
                  </>
                ) : (
                  <td colSpan={2} style={{ textAlign: "center", verticalAlign: "middle", height: "38px", padding: "2px 4px" }}>
                    {valueExtractor(row[0])}
                  </td>
                )}
              </tr>
            </thead>
          ))}
        </table>
      </div>
    );
  };

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 pb-0 pt-0">
              <div className="bd-example bd-example-tabs">
                <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-6 eodb-site-menu">
                    <div className="nav nav-tabs flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <a className="nav-link active show" id="eodb-1a"
                        data-toggle="pill" href="#eodb-1" role="tab" aria-controls="eodb-1" aria-selected="false">
                        {t("Building Construction Permit")}
                      </a>
                      <a className="nav-link" id="eodb-9a"
                        data-toggle="pill" href="#eodb-9" role="tab" aria-controls="eodb-9" aria-selected="false">
                        {t("Building EODB CC/OC")}
                      </a>
                      <a className="nav-link" id="eodb-2a" data-toggle="pill" href="#eodb-2"
                        role="tab" aria-controls="eodb-2" aria-selected="false">
                        {t("Civil- Road Cutting Permission")}
                      </a>
                      <a className="nav-link" id="eodb-3a" data-toggle="pill" href="#eodb-3"
                        role="tab" aria-controls="eodb-3" aria-selected="false">
                        {t("CE & Shops")}
                      </a>
                      <a className="nav-link" id="eodb-4a" data-toggle="pill" href="#eodb-4"
                        role="tab" aria-controls="eodb-4" aria-selected="true">
                        {t("Water Connection")}
                      </a>
                      <a className="nav-link" id="eodb-5a" data-toggle="pill" href="#eodb-5"
                        role="tab" aria-controls="eodb-5" aria-selected="true">
                        {t("Mutation")}
                      </a>
                      <a className="nav-link" id="eodb-6a" data-toggle="pill" href="#eodb-6"
                        role="tab" aria-controls="eodb-6" aria-selected="true">
                        {t("Signage License for Advertisement")}
                      </a>
                      <a className="nav-link" id="eodb-7a" data-toggle="pill" href="#eodb-7"
                        role="tab" aria-controls="eodb-7" aria-selected="true">
                        {t("Movie Shooting")}
                      </a>
                      <a className="nav-link" id="eodb-8a" data-toggle="pill" href="#eodb-8"
                        role="tab" aria-controls="eodb-8" aria-selected="true">
                        {t("Mobile Tower Approval")}
                      </a>
                      <a className="nav-link" href={`${mainURL}/KMCPortal/jsp/UserRegistration.jsp`}
                        target="_blank">
                        {t("Register")}
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-9 col-md-9 col-sm-6">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div className="tab-pane fade active show" id="eodb-1" role="tabpanel" aria-labelledby="eodb-1a">
                        <h3 className="eodb-titl">
                          {t("Building Construction Permit")}
                        </h3>
                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li> <a type="button" className="btn p-0" data-toggle="modal" data-target="#exampleModalCenter">
                              {t("About The Service")} <i className="bi bi-chevron-right" />
                            </a>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter" tabIndex={-1}
                            role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t(
                                      "About the service- Building Construction Permit"
                                    )}
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1">
                                    <img src="assets/img/logo.png" alt="alt-image" />
                                    <p>
                                      {t(
                                        "The online Building Construction Permit system has the following features without the requirement of physical visit href the department."
                                      )}
                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application")}.</li>
                                    <li>
                                      2. {t("Payment of Application Fees")}.
                                    </li>
                                    <li>
                                      3. {t("Track Status of Application")}.
                                    </li>
                                    <li>
                                      4.
                                      {t(
                                        "Download the Final Signed Certificate"
                                      )}
                                      .
                                    </li>
                                    <li>5. {t("Third Party Verification")}.</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                  >
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="eodb-pdf eodb-1">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo">
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo" className="collapse">
                                <ul>
                                  <li> <Link to="/Dashboard2"> {t("CAF")} </Link></li>
                                  <li> <Link to="/Dashboard2">{t("EoDB CAF DASHBOARD")} </Link></li>
                                  <li> <a href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/BuildingPlanSubmission.jsp`} target="_blank">
                                    {t("Common Application Form(CAF) for Building Construction Permit")}
                                  </a>
                                  </li>

                                  <li>
                                    <a href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/BuildingPlinthCmplDeclaration.jsp`} target="_blank">
                                      {t("Plinth Level")}
                                    </a>
                                  </li>
                                  <li>
                                    <a href="https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/KMCBuildingEODBCAF2.jsp">
                                      {t("Completion/ Occupancy Certificate")}
                                    </a>
                                  </li>
                                  <li> <Link to="/Dashboard2"> {t("NOC")} </Link></li>
                                  <li><a href={`https://www.kmcgov.in/KMCPortal/jsp/PlanProposalStatus.jsp`} target="_blank" >
                                    {t("Sanction Status")}
                                  </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"879a4e97-73a3-4943-a963-ed288d49d6c5"}
                                label={"Fees & Charges"}
                                classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"b4b58080-39d4-46dd-bca7-a588175472d2"}
                                label={"Procedures"}
                                classAdd={false} />
                            </li>

                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"708a17b1-e51a-4fbb-b6b9-66ac9f27679a"}
                                label={"List Of Documents"}
                                classAdd={false} />
                            </li>

                            <li> <Link to="/Building_Sanction_Important_EODB_circulars"> {t("Circulars")} </Link> </li>

                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"b6c9dc3e-b6d9-41ef-bcf2-8567422acd72"}
                                label={"Notification"}
                                classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"07534be3-21b7-4d17-b61b-a01e8eb1c80f"}
                                label={"Guidelines"}
                                classAdd={false} />
                            </li>
                          </ul>

                        </div>

                        <div className="eodb-pdf eodb-1">
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn p-0"
                              data-toggle="collapse" data-target="#demo1">
                              {t("Application Status")}
                              <i className="bi bi-chevron-right" />
                            </button>
                            <div id="demo1" className="collapse">
                              <div className="mayer-tb2">
                                <table className="deshbrd-tbl">
                                  <thead>
                                    <tr className="table-clr1">
                                      <th>Average Time Taken for Approval</th>
                                      <th>Total Number of Application Received</th>
                                    </tr>
                                    <tr>
                                      <td> 59 Days </td>
                                      <td>20008</td>
                                    </tr>
                                  </thead>
                                </table>
                              </div>
                            </div>
                          </li>
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn p-0" data-toggle="collapse" data-target="#demo2">
                              {t("Approval Time Statistics")}
                              <i className="bi bi-chevron-right" />
                            </button>
                            <div id="demo2" className="collapse">
                              <div className="mayer-tb2">
                                <table className="deshbrd-tbl">
                                  <thead>
                                    <tr className="table-clr2">
                                      <th colSpan={4}>Approval Time Statistics as on <span> August 24, 2026 </span></th>
                                    </tr>
                                    <tr className="table-clr1">
                                      <th> Average Time </th>
                                      <th> Median Time </th>
                                      <th> Minimum Time </th>
                                      <th> Maximum Time </th>
                                    </tr>
                                    <tr>
                                      <td> 59 Days</td>
                                      <td> 62.0 Days </td>
                                      <td> 5 Days </td>
                                      <td> 1397 Days </td>
                                    </tr>
                                  </thead>
                                </table>
                              </div>
                            </div>
                          </li>
                          <div>
                            <li className="eodb-pd-li m-0">
                              <button type="button" className="btn p-0" data-toggle="collapse" data-target="#demo3">
                                {t("WBRTPS Act")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo3" className="collapse">
                                <ul className="eodb-li">
                                  <li>
                                    <DownloadFileByFileStoreId
                                      fileStoreId={"27b9d8e9-7174-4977-a88d-dd429a06a8c5"}
                                      label={"Engineering"}
                                      classAdd={false} />
                                  </li>
                                  <li>
                                    <DownloadFileByFileStoreId
                                      fileStoreId={""}
                                      label={"Building"}
                                      classAdd={false} />
                                    {/* File not found */}
                                  </li>
                                  <li>
                                    <DownloadFileByFileStoreId
                                      fileStoreId={"5ea312f4-3de0-4030-88f8-43f43ac52b5e"}
                                      label={"KMDA"}
                                      classAdd={false} />
                                  </li>
                                  <li>
                                    <DownloadFileByFileStoreId
                                      fileStoreId={"16885894-0fc8-42bc-9066-1b28dd81e994"}
                                      label={"Fire"}
                                      classAdd={false} />
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </div>
                          <p />
                        </div>

                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li">
                            <li>
                              <a href="https://www.kmcgov.in/KMCPortal/jsp/PlanProposalStatus.jsp" target="_blank">
                                {t("Third Party Certification")}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="tab-pane fade" id="eodb-9" role="tabpanel" aria-labelledby="eodb-9a">
                        <h3 className="eodb-titl">
                          {t("Building EODB CC/OC")}
                        </h3>
                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <a type="button" className="btn p-0" data-toggle="modal" data-target="#exampleModalCenter1">
                                {t("About The Service")} <i className="bi bi-chevron-right" />
                              </a>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter1" tabIndex={-1}
                            role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t(
                                      "About the service- Building EODB CC OC Application"
                                    )}
                                  </h5>
                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1">
                                    <img src="assets/img/logo.png" alt="alt-image" />
                                    <p>
                                      {t(
                                        "The online Building EODB CC OC Application system has the following features without the requirement of physical visit to the department."
                                      )}
                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application")}.</li>
                                    <li>
                                      2. {t("Payment of Application Fees")}.
                                    </li>
                                    <li>
                                      3. {t("Track Status of Application")}.
                                    </li>
                                    <li>
                                      4.
                                      {t(
                                        "Download the Final Signed Certificate"
                                      )}
                                      .
                                    </li>
                                    <li>5. {t("Third Party Verification")}.</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="eodb-pdf eodb-1">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo">
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo" className="collapse">
                                <ul>
                                  <li> <Link to="/Dashboard2"> {t("EoDB CAF DASHBOARD")} </Link></li>
                                  <li>
                                    <a href="{'https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/KMCBuildingEODBCAF2.jsp`}">{t(" COMMON APPLICATION FORM (CAF2) FOR CC/OC ")} </a>
                                  </li>

                                  <li>
                                    <a href={`https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingEODBCAF2ShortfallDetails.jsp`} target="_blank">
                                      {t("LIST OF SHORTFALL DOCUMENT(S) REQUIRED")}
                                    </a>
                                  </li>
                                  <li>
                                    <a href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/KMCBuildingEODBCAF2ShortfallUpload.jsp`} target="_blank">
                                      {t(" BUILDING PLAN SHORTFALL DOCUMENT(S) UPLOAD")}
                                    </a>
                                  </li>
                                  <li>
                                    <a href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/KMCBuildingEODBCAF2DrawingReupload.jsp`} target="_blank">
                                      {t(" CAD DRAWING RE- UPLOAD")}
                                    </a>
                                  </li>

                                  <li>
                                    <a href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/KMCBuildingEODBCAF2JSIDetails.jsp`} target="_blank">
                                      {t("JOINT SITE INSPECTION DETAILS")} </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="eodb-pdf eodb-1">
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo11">
                              {t("View NOC For CC & OC")}
                              <i className="bi bi-chevron-right" />
                            </button>
                            <div id="demo11" className="collapse">
                              <li>
                                <a href="{'`}">{t(" WBF&ES ")} </a>
                              </li>

                              <li>
                                <a href={``} target="_blank">
                                  {t("FORM C (DIRECTORATE OF ELECTRICITY)")}
                                </a>
                              </li>
                              <li>
                                <a href={``} target="_blank">
                                  {t("WBPCB")}
                                </a>
                              </li>
                              <li>
                                <a href={``} target="_blank">
                                  {t("WATER SUPPLY/ KMC")}
                                </a>
                              </li>

                              <li>
                                <a href={``} target="_blank">
                                  {t(" ENGINEERING/ DRIANAGE, KMC")} </a>
                              </li>

                            </div>
                          </li>
                        </div>
                        <div className="eodb-pdf eodb-1">
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn p-0" data-toggle="collapse" data-target="#demo1">
                              {t("Fees & Charges")}
                              <i className="bi bi-chevron-right" />
                            </button>
                            <div id="demo1" className="collapse">
                              <li>
                                <DownloadFileByFileStoreId
                                  fileStoreId={"f9dcdb25-fc12-4bd6-aec3-1ae093839445"}
                                  label={"Fees & Charges"}
                                  classAdd={false} />
                              </li>

                            </div>
                          </li>
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn p-0" data-toggle="collapse" data-target="#demo2">
                              {t("Procedures")}
                              <i className="bi bi-chevron-right" />
                            </button>
                            <div id="demo2" className="collapse">
                              <li>
                                <DownloadFileByFileStoreId
                                  fileStoreId={"17d8d584-fd04-413a-a9a2-34053c481492"}
                                  label={"How To Apply Through CAF2 (CC&OC)"}
                                  classAdd={false} />
                              </li>
                              <li>
                                <DownloadFileByFileStoreId
                                  fileStoreId={"b2aa1689-c43d-44c9-9a26-0000f2d9ecb6"}
                                  label={"JOINT SITE INEPECTION FORMAT(CAF2)"}
                                  classAdd={false} />
                              </li>
                            </div>
                          </li>
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn p-0" data-toggle="collapse" data-target="#demo31">
                              {t("List Of Documents")}
                              <i className="bi bi-chevron-right" />
                            </button>
                            <div id="demo31" className="collapse">
                              <ul className="eodb-li">
                                <li>
                                  <DownloadFileByFileStoreId
                                    fileStoreId={"d6427f2b-31ce-42cb-b202-401f4c70aee7"}
                                    label={"Download Standard(.xls) format for MC Circular No.44 of 2021-22"}
                                    classAdd={false} />
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn p-0" data-toggle="collapse" data-target="#demo3">
                              {t("Circulars")}
                              <i className="bi bi-chevron-right" />
                            </button>
                            <div id="demo3" className="collapse">
                              <ul className="eodb-li">
                                <li>
                                  <DownloadFileByFileStoreId
                                    fileStoreId={"dd5f504a-f611-4974-a65c-43708333e928"}
                                    label={"MC Circular No.44 of 2021-22 Regarding Assessment Data at the time of CC"}
                                    classAdd={false} />
                                </li>
                              </ul>
                            </div>
                          </li>
                        </div>
                        <div className="eodb-pdf eodb-1">
                          <ul class="eodb-pd-li m-0">
                            <li>
                              <a href="" target="_blank">Notification</a>
                            </li>
                          </ul>
                        </div>
                        <div className="eodb-pdf eodb-1">
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn p-0" data-toggle="collapse" data-target="#demo32">
                              {t("Guidelines")}
                              <i className="bi bi-chevron-right" />
                            </button>
                            <div id="demo32" className="collapse">
                              <ul className="eodb-li">
                                <li>
                                  <DownloadFileByFileStoreId
                                    fileStoreId={""}
                                    label={"INSTRUCTION SET FOR CAD DRAWINGS FOR CC & OC (CC&OC)"}
                                    classAdd={false} />
                                </li>
                              </ul>
                            </div>
                          </li>
                        </div>

                        <div class="eodb-pdf eodb-1">
                          <li class="eodb-pd-li m-0">
                            <button type="button" class="btn p-0 collapsed" data-toggle="collapse" data-target="#demo1" aria-expanded="false">
                              Application Status<i class="bi bi-chevron-right"></i>
                            </button>
                            <div id="demo1" class="collapse">
                              <div className="mayer-tb2">
                                <table className="deshbrd-tbl">
                                  <thead>
                                    <tr className="table-clr1">
                                      <th>Time Line as per WBRTPS Act</th>
                                      <th>Average Time Taken for Approval</th>
                                      <th>Total Number of Application Received</th>
                                    </tr>
                                    <tr>
                                      <td> 7 Days </td>
                                      <td> 93 Days</td>
                                      <td> 2030   </td>
                                    </tr>
                                  </thead>
                                </table>
                              </div>
                            </div>
                          </li>

                          <li class="eodb-pd-li m-0">
                            <button type="button" class="btn p-0" data-toggle="collapse" data-target="#demo2">
                              Approval Time Statistics<i class="bi bi-chevron-right"></i>
                            </button>
                            <div id="demo2" class="collapse">
                              <div className="mayer-tb2">
                                <table className="deshbrd-tbl">
                                  <thead>
                                    <tr className="table-clr2">
                                      <th colSpan={4}> Approval Time Statistics as on   <span> August 24, 2026 </span></th>
                                    </tr>
                                    <tr className="table-clr1">
                                      <th> Average Time </th>
                                      <th> Median Time </th>
                                      <th> Minimum Time </th>
                                      <th> Maximum Time </th>
                                    </tr>
                                    <tr>
                                      <td> 93 Days</td>
                                      <td> 75.0 Days </td>
                                      <td> 6 Days </td>
                                      <td> 577 Days </td>
                                    </tr>
                                  </thead>
                                </table>
                              </div>

                            </div>
                          </li>
                        </div>

                        <div className="eodb-pdf">
                          <ul class="eodb-pd-li m-0">
                            <li>
                              <a href="" target="_blank">WBRTPS Act</a>
                            </li>
                          </ul>
                        </div>
                        <div className="eodb-pdf">
                          <ul class="eodb-pd-li m-0">
                            <li>
                              <a href="" target="_blank">Third Party Certification</a>
                            </li>
                          </ul>
                        </div>

                      </div>

                      <div className="tab-pane fade" id="eodb-2" role="tabpanel" aria-labelledby="eodb-2a">
                        <h3 className="eodb-titl">
                          {t("Civil- Road Cutting Permission")}
                        </h3>
                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <a type="button" className="btn p-0" data-toggle="modal" data-target="#exampleModalCenter2" >
                                {t("About The Service")} <i className="bi bi-chevron-right" />
                              </a>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter2" tabIndex={-1}
                            role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t(
                                      "About the service- Road Cutting Permission"
                                    )}
                                  </h5>
                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1">
                                    <img src="assets/img/logo.png" alt="alt-image" />
                                    <p>
                                      {t(
                                        "The online Road Cutting Permission system has the following features without the requirement of physical visit to the department."
                                      )}

                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application")}.</li>
                                    <li>
                                      2. {t("Payment of Application Fees")}.
                                    </li>
                                    <li>
                                      3. {t("Track Status of Application")}.
                                    </li>
                                    <li>
                                      4.
                                      {t(
                                        "Download the Final Signed Certificate"
                                      )}
                                      .
                                    </li>
                                    <li>5. {t("Third Party Verification")}.</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                  >
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo5">
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo5" className="collapse">
                                <ul>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`}>
                                      {t("Road Restoration Application")} </a>
                                  </li>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`}>
                                      {t("Road Restoration Dashboard")} </a>
                                  </li>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`}>
                                      {t("Application Status")} </a>
                                  </li>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`}>
                                      {t("Application Approval")} </a>
                                  </li>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`}>
                                      {t("Demand Download")} </a>
                                  </li>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`}>
                                      {t("Payment Submission")} </a>
                                  </li>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`}>
                                      {t("Kolkata Police Approval")} </a>
                                  </li>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`}>
                                      {t("Payment Confirmation")} </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"b53e01f7-07c0-432d-b6f8-18e0231f70ad"}
                                label={"Fees & Charges"}
                                classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"8ff3f6fc-5706-42fa-b7a0-3fe3dc7729d6"}
                                label={"Procedures"}
                                classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"7b5e4c1c-10e1-4c5f-92a5-00f488d7ec23"}
                                label={"List Of Documents"}
                                classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"786d7c00-2781-4195-b74f-9185e9a5acfb"}
                                label={"Circulars"} classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"be4fee1e-734b-4f2c-bdba-437ae6007c7f"}
                                label={"Notification"} classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"5df68faa-cf51-416d-b86e-0d353e121abc"}
                                label={"Guidelines"} classAdd={false} />
                            </li>
                          </ul>
                        </div>

                        <div className="eodb-pdf eodb-1">
                          <li className="eodb-pd-li m-0">
                            <button type="button" className="btn p-0 collapsed" data-toggle="collapse" data-target="#demo1" aria-expanded="false">
                              Application Status <span>  (Based on data from 1st November, 2020 onwards) </span><i className="bi bi-chevron-right"></i>
                            </button>
                            <div id="demo1" className="collapse">
                              <DynamicPieChart data={chartData} />

                              <div className="mayer-tb2">
                                <table className="deshbrd-tbl">
                                  <thead>
                                    <tr className="table-clr1">
                                      <th>Time Line as per WBRTPS Act</th>
                                      <th>Average Time Taken for Approval</th>
                                      <th>Total Number of Application Received</th>
                                    </tr>
                                    <tr>
                                      <td> - Days </td>
                                      <td> 57 Days</td>
                                      <td> {cmeData?.totalApplications != null ? cmeData.totalApplications : 83721} </td>
                                    </tr>
                                  </thead>
                                </table>
                              </div>

                            </div>
                          </li>

                          <li class="eodb-pd-li m-0">
                            <button type="button" class="btn p-0" data-toggle="collapse" data-target="#demo2">
                              Approval Time Statistics (Based on data from 1st November, 2020 onwards) <i class="bi bi-chevron-right"></i>
                            </button>
                            <div id="demo2" class="collapse">
                              <div className="mayer-tb2">
                                <table className="deshbrd-tbl">
                                  <thead>
                                    <tr className="table-clr2">
                                      <th colSpan={4}> Approval Time Statistics as on   <span> August 24, 2026 </span></th>
                                    </tr>
                                    <tr className="table-clr1">
                                      <th> Average Time </th>
                                      <th> Median Time </th>
                                      <th> Minimum Time </th>
                                      <th> Maximum Time </th>
                                    </tr>
                                    <tr>
                                      <td> 57 Days</td>
                                      <td> 38.0 Days </td>
                                      <td> 4 Days </td>
                                      <td> 768 Days </td>
                                    </tr>
                                  </thead>
                                </table>
                              </div>

                            </div>
                          </li>
                        </div>



                        <div className="eodb-pdf ">
                          <ul className="eodb-pd-li">
                            <li> <a href="#" target="_blank"> {t("WBRTPS APPLICATION")} </a>
                            </li>
                            <li>
                              <a href="#" target="_blank"> {t("Third Party Certification")} </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="tab-pane fade" id="eodb-3" role="tabpanel" aria-labelledby="eodb-3a">
                        <h3 className="eodb-titl"> {t("CE & Shops")} </h3>
                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <a type="button" className="btn p-0" data-toggle="modal"
                                data-target="#exampleModalCenter3">{t("About The Service")}  <i className="bi bi-chevron-right" />
                              </a>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter3" tabIndex={-1}
                            role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t("About the service- Trade Licence And Shop & Establishment")}
                                  </h5>
                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1">
                                    <img src="assets/img/logo.png" alt="alt-image" />
                                    <p>
                                      {t(
                                        "The online Trade Licence And Shop & Establishment system has the following features without the requirement of physical visit to the department."
                                      )}
                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application .")}</li>
                                    <li> 2. {t("Payment of Application Fees .")}</li>
                                    <li> 3. {t("Track Status of Application .")}</li>
                                    <li> 4. {t("Download the Final Signed Certificate.")}</li>
                                    <li>5. {t("Third Party Verification.")}</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-dismiss="modal" >
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo5">
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo5" className="collapse">
                                <ul className="">
                                  <li>
                                    <a href={`${mainURL}/citizen/language-selection`}>
                                      {t("New Certificate of Enlistment (CE)")}
                                    </a>
                                  </li>
                                  <li>
                                    <a href={`${mainURL}/citizen/language-selection`}>
                                      {t("New CE & Shop Registration")}
                                    </a>
                                  </li>
                                  <li>
                                    <a href={`${mainURL}/citizen/language-selection`}>
                                      {t("Online Payment (CE & Shops)")}
                                    </a>
                                  </li>
                                  <li><a href={`${mainURL}/citizen/language-selection`}>
                                    {t("e-Receipt (CE & Shops)")}
                                  </a>
                                  </li>
                                  <li><a href={`${mainURL}/citizen/language-selection`}>
                                    {t("Change Of CE")}
                                  </a>
                                  </li>
                                  <li><a href={`${mainURL}/citizen/language-selection`}>
                                    {t("Closure of CE")}
                                  </a>
                                  </li>
                                  <li> <a href={`${mainURL}/citizen/language-selection`}>
                                    {t("Renewal of CE")}
                                  </a>
                                  </li>
                                  <li>
                                    <a href={`${mainURL}/citizen/language-selection`}>
                                      {t("Search Application Status")}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"18080426-2a59-4f3c-8a94-891f18042026"}
                                label={"Fees & Charges"} classAdd={false} />
                            </li>
                            <li>
                              <a href={`https://www.kmcgov.in/KMCPortal/jsp/EODBLicenseHelpLineNumber.jsp`} target="_blank">
                                {t("HelpLine Number")}
                              </a>
                            </li>
                            <li>
                              <Link to="/Eodb_Wbrtps">  {t("WBRTPS")}  </Link>
                            </li>
                            <li>
                              <DownloadFileByFileStoreId fileStoreId={"2ebd5850-0804-4657-84ee-37a4146c2f6b"} label={"Procedures"} classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId fileStoreId={"539e8d56-ba7b-455b-9658-b77ea14b89ef"} label={"List Of Documents"} classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId fileStoreId={"0576fcd1-2c69-4f8c-acbe-33f747d49b32"} label={"Circulars"} classAdd={false} />
                            </li>
                            <li>
                              <a className="fontSizeClass"
                                data-toggle="modal" data-target="#exampleModal2" href="">
                                {t("Notification")}
                              </a>
                              <div class="modal fade" id="exampleModal2" tabindex="1" aria-labelledby="exampleModalLabe2" aria-hidden="true">
                                <div class="modal-dialog">
                                  <div class="modal-content">

                                    <div class="modal-header">
                                      <h5 class="modal-title" id="exampleModalLabel"> Please Note </h5>
                                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                    <div class="modal-body">
                                      {t(
                                        "There is no physical touch point in the online system for issue of Certificate of Enlistment (commonly known as trade licence) and renewal thereof and the online process is real time."
                                      )}
                                    </div>
                                    <div class="modal-footer">
                                      <button type="button" className="btn btn-primary not1" onClick={handleOrder} >
                                        {t("Order")}
                                      </button><a type="button" class="btn btn-primary not1" data-dismiss="modal"> Close </a>
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </li>
                            <li>
                              <DownloadFileByFileStoreId fileStoreId={"354fab8a-c6ca-4f16-9f3d-2183c156741f"} label={"Guidelines"} classAdd={false} />
                            </li>

                            <li className="eodb-pd-li m-0">
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo8">
                                {t("Application Status")} <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo8" className="collapse">
                                <div className="mayer-tb2">
                                  <table className="deshbrd-tbl">
                                    <thead>
                                      <tr className="table-clr1">
                                        <th>Time Line as per WBRTPS Act</th>
                                        <th>Average Time Taken for Approval</th>
                                        <th>Total Number of Application Received</th>
                                      </tr>
                                      <tr>
                                        <td> - Days </td>
                                        <td>
                                          <div className="mayer-tb2">
                                            <table className="deshbrd-tbl">
                                              <thead>
                                                <tr className="table-clr1">
                                                  <th>Demand Generated</th>
                                                  <th>Status Request Completed</th>
                                                </tr>
                                                <tr>
                                                  <td> - Days </td>
                                                  <td> - Days </td>
                                                </tr>
                                              </thead>
                                            </table>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="mayer-tb2">
                                            <table className="deshbrd-tbl">
                                              <thead>
                                                <tr className="table-clr1">
                                                  <th>Demand Generated</th>
                                                  <th>Status Request Completed</th>
                                                </tr>
                                                <tr>
                                                  <td> -  </td>
                                                  <td> -  </td>
                                                </tr>
                                              </thead>
                                            </table>
                                          </div>
                                        </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </li>
                            <li className="eodb-pd-li m-0">
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo9">
                                {t("Approval Time Statistics")} <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo9" className="collapse">
                                <div className="card card-body">
                                  <div className="mayer-tb2">
                                    <table className="deshbrd-tbl">
                                      <thead>
                                        <tr className="table-clr2">
                                          <th colSpan={4}>Approval Time Statistics as on <span> August 24, 2026 </span></th>
                                        </tr>
                                        <tr className="table-clr1">
                                          <th>Average Time</th>
                                          <th>Median Time</th>
                                          <th>Minimum Time</th>
                                          <th>Maximum Time</th>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div className="mayer-tb2">
                                              <table className="deshbrd-tbl">
                                                <thead>
                                                  <tr className="table-clr1">
                                                    <th>Demand Generated</th>
                                                    <th>Status Request Completed</th>
                                                  </tr>
                                                  <tr>
                                                    <td> - Days </td>
                                                    <td> - Days </td>
                                                  </tr>
                                                </thead>
                                              </table>
                                            </div>

                                          </td>
                                          <td>
                                            <div className="mayer-tb2">
                                              <table className="deshbrd-tbl">
                                                <thead>
                                                  <tr className="table-clr1">
                                                    <th>Demand Generated</th>
                                                    <th>Status Request Completed</th>
                                                  </tr>
                                                  <tr>
                                                    <td> - Days </td>
                                                    <td> - Days </td>
                                                  </tr>
                                                </thead>
                                              </table>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="mayer-tb2">
                                              <table className="deshbrd-tbl">
                                                <thead>
                                                  <tr className="table-clr1">
                                                    <th>Demand Generated</th>
                                                    <th>Status Request Completed</th>
                                                  </tr>
                                                  <tr>
                                                    <td> - Days </td>
                                                    <td> - Days </td>
                                                  </tr>
                                                </thead>
                                              </table>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="mayer-tb2">
                                              <table className="deshbrd-tbl">
                                                <thead>
                                                  <tr className="table-clr1">
                                                    <th>Demand Generated</th>
                                                    <th>Status Request Completed</th>
                                                  </tr>
                                                  <tr>
                                                    <td> - Days </td>
                                                    <td> - Days </td>
                                                  </tr>
                                                </thead>
                                              </table>
                                            </div>
                                          </td>

                                        </tr>
                                      </thead>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li> <a href="" target="_blank"> {t("WBRTPS Act")}</a>
                            </li>
                            <li><a href={`https://kmc-dev.ddns.net/enlistment-fe/viewCeSearch`} target="_blank">
                              {t("Third Party Certification")}
                            </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="eodb-4" role="tabpanel" aria-labelledby="eodb-4a">
                        <h3 className="eodb-titl"> {t("Water Connection")} </h3>
                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <button type="button" className="btn p-0" data-toggle="modal" data-target="#exampleModalCenter4">
                                {t("About The Service")} <i className="bi bi-chevron-right" />
                              </button>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter4" tabIndex={-1} role="dialog"
                            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t("About the service- Water Connection")}
                                  </h5>
                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1">
                                    <img src="assets/img/logo.png" alt="alt-image" />
                                    <p>
                                      {t(
                                        "The online Water Connection system has the following features without the requirement of physical visit to the department."
                                      )}
                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application.")}</li>
                                    <li> 2. {t("Payment of Application Fees.")} </li>
                                    <li> 3. {t("Track Status of Application.")}</li>
                                    <li> 4. {t("Download the Final Signed Certificate.")}
                                    </li>
                                    <li>5. {t("Third Party Verification")}.</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo10">
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo10" className="collapse">
                                <ul className="">
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`} target="_blank">
                                      {t("Apply for New Online Domestic Water Connection")}
                                    </a>
                                  </li>
                                  <li>
                                    <a href={`${prodURL}/citizen/language-selection`} target="_blank">
                                      {t("Search Online Domestic Water Connection Application")}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li>
                              <Link className="fontSizeClass" to={"/Water_Supply"}>
                                {t("Information on tariffs on Water (For Domestic,Comme & Industrial User)")}
                              </Link>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Fees & Charges")}
                              </a>
                            </li>
                            <li>
                              <DownloadFileByFileStoreId fileStoreId={"5ae1fe2c-510f-4f3b-b2ba-0adcc818f98f"} label={"Procedures"} classAdd={false} />
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("List Of Documents")}
                              </a>
                            </li>

                            <li>
                              <a href="" target="_blank">
                                {t("Circulars")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Notification")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Guidelines")}
                              </a>
                            </li>
                            <li className="eodb-pd-li m-0">
                              <button type="button" className="btn pl-0"
                                data-toggle="collapse" data-target="#demo11">
                                {t("Application Status")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo11" className="collapse">
                                <div className="mayer-tb2">
                                  <table className="deshbrd-tbl">
                                    <thead>
                                      <tr className="table-clr1">
                                        <th>Time Line as per WBRTPS Act</th>
                                        <th>Average Time Taken for Approval</th>
                                        <th>Total Number of Application Received</th>
                                      </tr>
                                      <tr>
                                        <td>7 Days </td>
                                        <td>28 Days</td>
                                        <td>190</td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </li>
                            <li className="eodb-pd-li m-0">
                              <button
                                type="button"
                                className="btn pl-0"
                                data-toggle="collapse"
                                data-target="#demo12">
                                {t("Approval Time Statistics")}
                                <i className="bi bi-chevron-right" />
                              </button>

                              <div id="demo12" className="collapse">

                                <div className="mayer-tb2">
                                  <table className="deshbrd-tbl">
                                    <thead>
                                      <tr className="table-clr2">
                                        <th colSpan={4}> Approval Time Statistics as on   <span> August 24, 2026 </span></th>
                                      </tr>
                                      <tr className="table-clr1">
                                        <th> Average Time </th>
                                        <th> Median Time </th>
                                        <th> Minimum Time </th>
                                        <th> Maximum Time </th>
                                      </tr>
                                      <tr>
                                        <td> 28 Days</td>
                                        <td> 12.0 Days </td>
                                        <td> 343 Days </td>
                                        <td> 343 Days </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>

                              </div>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("WBRTPS Act")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Third Party Certification")}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="eodb-5" role="tabpanel" aria-labelledby="eodb-5a">
                        <h3 className="eodb-titl"> {t("Mutation")} </h3>
                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <a type="button" className="btn p-0"
                                data-toggle="modal" data-target="#exampleModalCenter5">
                                {t("About The Service")} <i className="bi bi-chevron-right" />
                              </a>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter5" tabIndex={-1} role="dialog"
                            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t("About the Mutation")}
                                  </h5>
                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1">
                                    <img src="assets/img/logo.png" alt="alt-image" />
                                    <p>
                                      {t(
                                        "The online Building Construction Permit system has the following features without the requirement of physical visit href the department ."
                                      )}

                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application")}.</li>
                                    <li>
                                      2. {t("Payment of Application Fees")}.
                                    </li>
                                    <li>
                                      3. {t("Track Status of Application")}.
                                    </li>
                                    <li>
                                      4.
                                      {t(
                                        "Download the Final Signed Certificate"
                                      )}
                                      .
                                    </li>
                                    <li>5. {t("Third Party Verification")}.</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo13">
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo13" className="collapse">
                                <ul className="">
                                  <li>
                                    <a href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/AssesseeMutationApplication.jsp`} target="_blank">
                                      {t("NEW APPLICATION")}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href={`https://www.kmcgov.in/KMCPortal/jsp/MutaStatusSearch.jsp`} target="_blank">
                                      {t("STATUS SEARCH")}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/MutationPrint.jsp`}
                                      target="_blank">
                                      {t("DEMAND PRINT")}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/MutationProcessingFeesPayment.jsp`}
                                      target="_blank">
                                      {t("E-MUTATION FEES PAYMENT")}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/MutationPaymentReceipt.jsp`}
                                      target="_blank">
                                      {t("RECEIPT REPRINT")}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li">
                            <li>
                              <a
                                href={`https://www.kmcgov.in/KMCPortal/jsp/KMCAssessmentTaxRates.jsp`}
                                target="_blank">
                                {t("Fees & Charges")}
                              </a>
                            </li>
                            <li>
                              <Link className="fontSizeClass" to={"/Assessment_collection_Process_Muation"}>
                                {t("Procedures")}
                              </Link>
                            </li>
                            <li>
                              <a href="" target="_blank"> {t("List Of Documents")}</a>
                            </li>
                            <li>
                              <a href="" target="_blank"> {t("Circulars")}  </a>
                            </li>
                            <li>
                              <a
                                href={``} target="_blank">
                                {t("Notification")}
                              </a>
                            </li>
                            <li>
                              <a href={``} target="_blank" >
                                {t("Guidelines")}
                              </a>
                            </li>
                            <li className="eodb-pd-li m-0">
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo14">
                                {t(" Application Status (Based on data from 1st November, 2020 onwards)")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo14" className="collapse">
                                <MutationPieChart mutationData={mutationData} loading={loadingMutation} />
                                <div className="mayer-tb2 table-responsive" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                                  <table className="deshbrd-tbl" style={{ minWidth: "620px", width: "100%", tableLayout: "fixed" }}>
                                    <thead>
                                      <tr className="table-clr1">
                                        <th style={{ width: "26%", textAlign: "center", verticalAlign: "middle" }}>Time Line as per WBRTPS Act</th>
                                        <th style={{ width: "37%", textAlign: "center", verticalAlign: "middle" }}>Average Time Taken for Approval</th>
                                        <th style={{ width: "37%", textAlign: "center", verticalAlign: "middle" }}>Total Number of Application Received</th>
                                      </tr>
                                      <tr>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                          <div style={{ textAlign: "center", lineHeight: "1.2", padding: "2px 0" }}>
                                            <div>-</div>
                                            <div>Days</div>
                                          </div>
                                        </td>
                                        <td style={{ verticalAlign: "top", padding: "0 6px" }}>
                                          {renderNestedMutationTable((item) => formatDays(item?.averageTime))}
                                        </td>
                                        <td style={{ verticalAlign: "top", padding: "0 6px" }}>
                                          {renderNestedMutationTable((item) => formatCount(item?.totalRegistered ?? item?.totalReceived))}
                                        </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </li>
                            <li className="eodb-pd-li m-0">
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo15">
                                {t("Approval Time Statistics (Based on data from 1st November, 2020 onwards)")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo15" className="collapse">
                                <div className="mayer-tb2 table-responsive" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                                  <table className="deshbrd-tbl" style={{ minWidth: "750px", width: "100%", tableLayout: "fixed" }}>
                                    <thead>
                                      <tr className="table-clr1">
                                        <th style={{ width: "25%", textAlign: "center", verticalAlign: "middle" }}>Average Time</th>
                                        <th style={{ width: "25%", textAlign: "center", verticalAlign: "middle" }}>Median Time</th>
                                        <th style={{ width: "25%", textAlign: "center", verticalAlign: "middle" }}>Minimum Time</th>
                                        <th style={{ width: "25%", textAlign: "center", verticalAlign: "middle" }}>Maximum Time</th>
                                      </tr>
                                      <tr>
                                        <td style={{ verticalAlign: "top", padding: "0 6px" }}>
                                          {renderNestedMutationTable((item) => formatDays(item?.averageTime))}
                                        </td>
                                        <td style={{ verticalAlign: "top", padding: "0 6px" }}>
                                          {renderNestedMutationTable((item) => formatDays(item?.meanTime ?? item?.medianTime))}
                                        </td>
                                        <td style={{ verticalAlign: "top", padding: "0 6px" }}>
                                          {renderNestedMutationTable((item) => formatDays(item?.minimumTime))}
                                        </td>
                                        <td style={{ verticalAlign: "top", padding: "0 6px" }}>
                                          {renderNestedMutationTable((item) => formatDays(item?.maximumTime))}
                                        </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </li>
                            <li> <a href="" target="_blank"> {t("WBRTPS Act")}</a> </li>
                            <li> <a href="" target="_blank"> {t("Third Party Certification")}</a> </li>

                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="eodb-6" role="tabpanel" aria-labelledby="eodb-6a">
                        <h3 className="eodb-titl"> {t("Signage License for Advertisement")}
                        </h3>
                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <a type="button" className="btn p-0" data-toggle="modal" data-target="#exampleModalCenter6">
                                {t("About The Service")} <i className="bi bi-chevron-right" />
                              </a>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter6"
                            tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t("About the service- Signage License for Advertisement")}
                                  </h5>
                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1"> <img src="assets/img/logo.png" alt="alt-image" />
                                    <p>
                                      {t(
                                        "The online Signage License for Advertisement system has the following features without the requirement of physical visit to the department"
                                      )}
                                      .
                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application")}.</li>
                                    <li>
                                      2. {t("Payment of Application Fees")}.
                                    </li>
                                    <li>
                                      3. {t("Track Status of Application")}.
                                    </li>
                                    <li>
                                      4.
                                      {t(
                                        "Download the Final Signed Certificate"
                                      )}
                                      .
                                    </li>
                                    <li>5. {t("Third Party Verification")}.</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                  >
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li className="">
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo5" >
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo5" className="collapse">
                                <ul className="">
                                  <li>
                                    <a href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/AdvertisementOnlineApplication.jsp`}
                                      target="_blank">
                                      {t("Apply for New Online Application")}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/AdvertisementOnlineRenewApplication.jsp`}
                                      target="_blank">
                                      {t("Apply for Renew Application")}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/AdvertisementOnlineApplicationStatus.jsp`}
                                      target="_blank">
                                      {t("Search Online Application Status")}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href={`https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/AdvertisementOnlineApplicationNOC.jsp`}
                                      target="_blank">
                                      {t("Online Application NOC")}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li>
                              <a
                                href={`https://www.kmcgov.in/KMCPortal/jsp/AdvertisementRates.jsp`}
                                target="_blank">
                                {t("Fees & Charges")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Procedures")}
                              </a>
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={"3dbf9b64-13d8-46c9-8821-8407d09305d9"}
                                label={"List Of Documents"} classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={""}
                                label={"Circulars"} classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={""}
                                label={"Notification"} classAdd={false} />
                            </li>
                            <li>
                              <DownloadFileByFileStoreId
                                fileStoreId={""}
                                label={"Guidelines"} classAdd={false} />
                            </li>
                            <li className="eodb-pd-li m-0">
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo16">
                                {t("Application Status")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo16" className="collapse">
                                <div class="mayer-tb2">
                                  <table class="deshbrd-tbl">
                                    <thead>
                                      <tr class="table-clr1">
                                        <th>Time Line as per WBRTPS Act</th>
                                        <th>Average Time Taken for Approval</th>
                                        <th>Total Number of Application Received</th>
                                      </tr>
                                      <tr>
                                        <td> Days </td>
                                        <td> Days</td>
                                        <td> Days </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </li>
                            <li className="eodb-pd-li m-0">
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo17">
                                {t("Approval Time Statistics")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo17" className="collapse">
                                <div class="mayer-tb2">
                                  <table class="deshbrd-tbl">
                                    <thead>
                                      <tr class="table-clr2">
                                        <th colspan="4"> Approval Time Statistics as on   <span> September 3, 2026 </span></th>
                                      </tr>
                                      <tr class="table-clr1">
                                        <th> Average Time </th>
                                        <th> Median Time </th>
                                        <th> Minimum Time </th>
                                        <th> Maximum Time </th>
                                      </tr>
                                      <tr>
                                        <td> Days</td>
                                        <td> Days </td>
                                        <td> Days </td>
                                        <td> Days </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("WBRTPS Act")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Third Party Certification")}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="eodb-7" role="tabpanel" aria-labelledby="eodb-7a">
                        <h3 className="eodb-titl"> {t("Movie Shooting")} </h3>

                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <a type="button" className="btn p-0" data-toggle="modal" data-target="#exampleModalCenter7">
                                {t("About The Service")} <i className="bi bi-chevron-right" />
                              </a>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter7" tabIndex={-1} role="dialog"
                            aria-labelledby="exampleModalCenterTitle" aria-hidden="true" >
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t("About the service- >Movie Shooting")}
                                  </h5>
                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1">
                                    <img src="assets/img/logo.png" alt="alt-image" />
                                    <p>
                                      {t(
                                        "The online >Movie Shooting system has the following features without the requirement of physical visit to the department"
                                      )}
                                      .
                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application")}.</li>
                                    <li> 2. {t("Payment of Application Fees")}. </li>
                                    <li> 3. {t("Track Status of Application")}.</li>
                                    <li> 4. {t("Download the Final Signed Certificate")}.</li>
                                    <li>5. {t("Third Party Verification")}.</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li">
                            <li className="">
                              <button type="button" className="btn p-0" data-toggle="collapse" data-target="#demo18">
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo18" className="collapse">
                                <ul className="mt-1">
                                  <li>
                                    <a href="" target="_blank">
                                      {t("New")}
                                    </a>
                                  </li>
                                  <li>
                                    <a href="" target="_blank">
                                      {t("Renewal")}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Fees & Charges")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Procedures")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("List Of Documents")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Circulars")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Notification")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Guidelines")}
                              </a>
                            </li>
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo19">
                                {t("Application Status")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo19" className="collapse">
                                <div class="mayer-tb2">
                                  <table class="deshbrd-tbl">
                                    <thead>
                                      <tr class="table-clr1">
                                        <th>Time Line as per WBRTPS Act</th>
                                        <th>Average Time Taken for Approval</th>
                                        <th>Total Number of Application Received</th>
                                      </tr>
                                      <tr>
                                        <td> Days </td>
                                        <td> Days</td>
                                        <td> Days </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>

                              </div>
                            </li>
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo20" >
                                {t("Approval Time Statistics")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo20" className="collapse">
                                <div class="mayer-tb2">
                                  <table class="deshbrd-tbl">
                                    <thead>
                                      <tr class="table-clr2">
                                        <th colspan="4"> Approval Time Statistics as on   <span> September 3, 2026 </span></th>
                                      </tr>
                                      <tr class="table-clr1">
                                        <th> Average Time </th>
                                        <th> Median Time </th>
                                        <th> Minimum Time </th>
                                        <th> Maximum Time </th>
                                      </tr>
                                      <tr>
                                        <td> Days</td>
                                        <td> Days </td>
                                        <td> Days </td>
                                        <td> Days </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>

                              </div>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("WBRTPS Act")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Third Party Certification")}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="eodb-8" role="tabpanel" aria-labelledby="eodb-8a">
                        <h3 className="eodb-titl"> {t("Mobile Tower Approval")} </h3>
                        <div className="eodb-but1 eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <a type="button" className="btn p-0" data-toggle="modal" data-target="#exampleModalCenter8">
                                {t("About The Service")}
                                <i className="bi bi-chevron-right" />
                              </a>
                            </li>
                          </ul>
                          <div className="modal fade" id="exampleModalCenter8" tabIndex={-1}
                            role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="exampleModalLongTitle">
                                    {t(
                                      "About the service- Mobile Tower Approval"
                                    )}
                                  </h5>
                                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="mod-hed-1">
                                    <img
                                      src="assets/img/logo.png"
                                      alt="alt-image"
                                    />
                                    <p>
                                      {t(
                                        "The online Mobile Tower Approval system has the following features without the requirement of physical visit to the department."
                                      )}
                                      .
                                    </p>
                                  </div>
                                  <ul className="model-list">
                                    <li>1. {t("Submision of Application")}.</li>
                                    <li>
                                      2. {t("Payment of Application Fees")}.
                                    </li>
                                    <li>
                                      3. {t("Track Status of Application")}.
                                    </li>
                                    <li>
                                      4.
                                      {t(
                                        "Download the Final Signed Certificate"
                                      )}
                                      .
                                    </li>
                                    <li>5. {t("Third Party Verification")}.</li>
                                  </ul>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                  >
                                    {t("Thank You")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="eodb-pdf">
                          <ul className="eodb-pd-li m-0">
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo19" >
                                {t("Application")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo19" className="collapse">
                                <ul className="mt-1">
                                  <li>
                                    <a href="" target="_blank">
                                      {t("New")}
                                    </a>
                                  </li>
                                  <li>
                                    <a href="" target="_blank">
                                      {t("Renewal")}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Fees & Charges")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Procedures")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("List Of Documents")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Circulars")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Notification")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Guidelines")}
                              </a>
                            </li>
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo19a">
                                {t("Application Status")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo19a" className="collapse">
                                <div class="mayer-tb2">
                                  <table class="deshbrd-tbl">
                                    <thead>
                                      <tr class="table-clr1">
                                        <th>Time Line as per WBRTPS Act</th>
                                        <th>Average Time Taken for Approval</th>
                                        <th>Total Number of Application Received</th>
                                      </tr>
                                      <tr>
                                        <td> Days </td>
                                        <td> Days</td>
                                        <td> Days </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>

                              </div>
                            </li>
                            <li>
                              <button type="button" className="btn pl-0" data-toggle="collapse" data-target="#demo20a" >
                                {t("Approval Time Statistics")}
                                <i className="bi bi-chevron-right" />
                              </button>
                              <div id="demo20a" className="collapse">
                                <div class="mayer-tb2">
                                  <table class="deshbrd-tbl">
                                    <thead>
                                      <tr class="table-clr2">
                                        <th colspan="4"> Approval Time Statistics as on   <span> September 3, 2026 </span></th>
                                      </tr>
                                      <tr class="table-clr1">
                                        <th> Average Time </th>
                                        <th> Median Time </th>
                                        <th> Minimum Time </th>
                                        <th> Maximum Time </th>
                                      </tr>
                                      <tr>
                                        <td> Days</td>
                                        <td> Days </td>
                                        <td> Days </td>
                                        <td> Days </td>
                                      </tr>
                                    </thead>
                                  </table>
                                </div>

                              </div>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("WBRTPS Act")}
                              </a>
                            </li>
                            <li>
                              <a href="" target="_blank">
                                {t("Third Party Certification")}
                              </a>
                            </li>

                          </ul>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
